// @flow
import {
  RISK_CHART_X_CHANGE,
  RISK_CHART_Y_CHANGE,
  RISK_CHART_DATA_CHANGE,
  RISK_CHART_CHECKED_CHANGE,
  UPDATE_ALL_OPEN_TRADES,
  UPDATE_SELECTED_TRADE,
  UPDATE_SELECTED_TRADE_INDEX,
  UPDATE_SELECTED_DATE_FILTER,
  UPDATE_SELECTED_DATE_Y
} from '../../actions/risk'
import type {
  RISK_CHART_X_CHANGE_TYPE,
  RISK_CHART_Y_CHANGE_TYPE,
  RISK_CHART_DATA_CHANGE_TYPE,
  RISK_CHART_CHECKED_CHANGE_TYPE,
  UPDATE_ALL_OPEN_TRADES_TYPE,
  UPDATE_SELECTED_TRADE_TYPE,
  UPDATE_SELECTED_TRADE_INDEX_TYPE,
  UPDATE_SELECTED_DATE_FILTER_TYPE,
  UPDATE_SELECTED_DATE_Y_TYPE
} from '../../actions/risk'

type State = {
  allX: number[],
  allY: number[][],
  data: Object[],
  checkedList: number[],
  openTrades: Object[],
  selectedTrade: Object,
  selectedIndex: number[],
  selectedDateFilter: Object,
  dateFilterY: number[][]
}

type Action =
  | RISK_CHART_X_CHANGE_TYPE
  | RISK_CHART_Y_CHANGE_TYPE
  | RISK_CHART_DATA_CHANGE_TYPE
  | RISK_CHART_CHECKED_CHANGE_TYPE
  | UPDATE_ALL_OPEN_TRADES_TYPE
  | UPDATE_SELECTED_TRADE_TYPE
  | UPDATE_SELECTED_TRADE_INDEX_TYPE
  | UPDATE_SELECTED_DATE_FILTER_TYPE
  | UPDATE_SELECTED_DATE_Y_TYPE

const initialState: State = {
  allX: [],
  allY: [],
  data: [],
  checkedList: [],
  openTrades: [],
  selectedTrade: {},
  selectedIndex: [],
  selectedDateFilter: {},
  dateFilterY: []
}

export default function riskReducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case RISK_CHART_X_CHANGE: {
      const { allX } = action.payload
      return {
        ...state,
        allX
      }
    }
    case RISK_CHART_Y_CHANGE: {
      const newY = action.payload.allY
      const index = action.payload.index
      const allY: number[][] = state.allY
      allY[index] = newY
      return {
        ...state,
        allY
      }
    }
    case RISK_CHART_DATA_CHANGE: {
      const { data } = action.payload
      return {
        ...state,
        data
      }
    }
    case RISK_CHART_CHECKED_CHANGE: {
      const { checkedList } = action.payload
      return {
        ...state,
        checkedList
      }
    }
    case UPDATE_ALL_OPEN_TRADES: {
      const { openTrades } = action.payload
      return {
        ...state,
        openTrades
      }
    }
    case UPDATE_SELECTED_TRADE: {
      const { selectedTrade } = action.payload
      return {
        ...state,
        selectedTrade
      }
    }
    case UPDATE_SELECTED_TRADE_INDEX: {
      const { selectedIndex } = action.payload
      return {
        ...state,
        selectedIndex
      }
    }
    case UPDATE_SELECTED_DATE_FILTER: {
      const { selectedDateFilter } = action.payload
      return {
        ...state,
        selectedDateFilter
      }
    }
    case UPDATE_SELECTED_DATE_Y: {
      const newY = action.payload.dateFilterY
      const index = action.payload.index
      const dateFilterY: number[][] = state.dateFilterY
      dateFilterY[index] = newY
      return {
        ...state,
        dateFilterY
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/risk/index.js